<template>
    <div class="search-container">
        <!-- Search modal -->
        <div class="modal fade" id="searchOrderModal" tabindex="-1" aria-labelledby="searchOrderModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-fullscreen">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="searchOrderModalLabel">Search Order</h5>
                        <button type="button" class="btn btn-sm btn-outline-danger" data-bs-dismiss="modal" aria-label="Close">Close</button>
                    </div>
                    <div class="modal-body">
                        <div class="row d-flex">
                            <div class="col-lg-4 col-md-12">
                                <div class="card h-100">
                                    <div class="card-header text-black p-2">General Search</div>
                                    <div class="card-body pt-0">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <label for="search" class="form-label">Search by keyword</label>
                                                <input 
                                                    v-model="searchTerm" 
                                                    type="text" 
                                                    class="form-control" 
                                                    placeholder="Search by keyword"
                                                    @input="generalSearch"
                                                >
                                                <small class="form-text text-muted">
                                                    You can search by customer name, address, service,<br/>
                                                    Or date — try formats like <strong>today</strong>, <strong>tomorrow</strong>, <strong>{{ exampleDate }}</strong>, <strong>{{ exampleMonthYear }}</strong>, or <strong>{{ exampleYear }}</strong>.
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-8 col-md-12">
                                <div class="card h-100">
                                    <div class="card-header text-black p-2">Advanced Search</div>
                                    <div class="card-body pt-0">
                                        <div class="row">
                                            <div class="col-md-3">
                                                <label for="customer" class="form-label">Select Customer</label>
                                                <VueSelect
                                                    v-model="filters.customers"
                                                    :items="customerOptions"
                                                    :searchable="true"
                                                    :multiple="true"
                                                    :placeholder="'Select Customers'"
                                                    @onSelectOption="handleCustomerSelect"
                                                    @onRemoveOption="handleCustomerRemove"
                                                ></VueSelect>
                                                
                                            </div>
                                            <div class="col-md-3">
                                                <label for="property" class="form-label">Select Property</label>
                                                <vue-multiselect
                                                    v-model="filters.properties"
                                                    class="w-100"
                                                    :options="propertyOptions"
                                                    :placeholder="'Select Properties'"
                                                    :show-labels="false"
                                                    track-by="name"
                                                    label="name"
                                                    :multiple="true"
                                                    :searchable="true"
                                                    :group-select="false"
                                                    group-values="properties"
                                                    group-label="group"
                                                    @select="handlePropertySelect($event)"
                                                ></vue-multiselect>
                                            </div>
                                            <div class="col-md-3">
                                                <label for="handyman" class="form-label">Select Handyman</label>
                                                <VueSelect
                                                    v-model="filters.handymans"
                                                    :items="handymanOptions"
                                                    :searchable="true"
                                                    :multiple="true"
                                                    class="w-100"
                                                    :placeholder="'Select Handyman'"
                                                    @onSelectOption="handleHandymanSelect"
                                                ></VueSelect>
                                            </div>
                                            <div class="col-md-3">
                                                <label for="service" class="form-label">Service</label>
                                                <VueSelect
                                                    v-model="filters.service"
                                                    :items="serviceOptions"
                                                    :searchable="true"
                                                    :multiple="true"
                                                    class="w-100"
                                                    :placeholder="'Select Service'"
                                                    @onSelectOption="handleServiceSelect"
                                                ></VueSelect>
                                            </div>
                                            <div class="col-md-3">
                                                <label for="status" class="form-label">Status</label>
                                                <VueSelect
                                                    v-model="filters.status"
                                                    :items="statusOptions"
                                                    :searchable="true"
                                                    :multiple="true"
                                                    :placeholder="'Select Status'"
                                                    @onSelectOption="handleStatusSelect"
                                                ></VueSelect>
                                            </div>
                                            <div class="col-md-3">
                                                <label for="date_range" class="form-label">Date Range</label>
                                                <VueSelect
                                                    v-model="filters.date_type"
                                                    :items="[
                                                        { id: 'last_7_days', name: 'Last 7 Days' },
                                                        { id: 'last_15_days', name: 'Last 15 Days' },
                                                        { id: 'last_30_days', name: 'Last 30 Days' },
                                                        { id: 'this_month', name: 'This Month' },
                                                        { id: 'last_month', name: 'Last Month' },
                                                        { id: 'this_year', name: 'This Year' },
                                                        { id: 'last_year', name: 'Last Year' },
                                                        { id: 'custom', name: 'Custom' }
                                                    ]"
                                                    :searchable="false"
                                                    :multiple="false"
                                                    :placeholder="'Select Date Range'"
                                                ></VueSelect>
                                            </div>
                                            <template v-if="filters.date_type==='custom'" class="row g-3">
                                                <div class="col-md-3">
                                                    <label for="startDate" class="form-label">Start Date:</label>
                                                    <VueDatePicker
                                                        v-model="filters.start_date"
                                                        :enable-time-picker="false"
                                                        :clearable="false"
                                                        :format="'dd-MM-yyyy'"
                                                        :timezone="'UTC'"
                                                        :auto-apply="true"
                                                    />
                                                </div>
                                                <div class="col-md-3">
                                                    <label for="endDate" class="form-label">End Date:</label>
                                                    <VueDatePicker
                                                        v-model="filters.end_date"
                                                        :enable-time-picker="false"
                                                        :clearable="false"
                                                        :format="'dd-MM-yyyy'"
                                                        :timezone="'UTC'"
                                                        :auto-apply="true"
                                                    />
                                                </div>
                                            </template>
                                            <div class="col-md-3">
                                                <!-- Clear button will be visible when any filter is applied -->
                                                <label for="clear" class="form-label">&nbsp;</label>
                                                <div class="d-flex justify-content-start align-items-center mt-1">
                                                    <button 
                                                        v-if="filters.customers || filters.properties || filters.handymans || filters.service || filters.date_range || filters.status"
                                                        type="button" 
                                                        class="btn btn-sm btn-outline-danger" 
                                                        v-text="'Clear Filters'"
                                                        @click="clearSearch" 
                                                    ></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Order listing -->
                        <div class="row mt-3">
                            <div class="col-lg-7 col-md-12">
                                <div class="card">
                                    <div class="card-header text-black p-2">Orders</div>
                                    <div class="card-body p-2">
                                        <div class="table-responsive">
                                            <Vue3EasyDataTable
                                                ref="orderTable"
                                                :headers="orderDataTableObj.headers"
                                                :items="orderDataTableObj.items"
                                                :rows-per-page="10"
                                                :loading="orderDataTableObj.loading"
                                                buttons-pagination
                                                theme-color="#1d90ff"
                                                table-class-name="hm-easy-table"
                                            >
                                                <template #loading>
                                                    <Loader />
                                                </template>
                                                
                                                <template #item-booking_date="order">
                                                    <div class="text-nowrap" @contextmenu.prevent.stop="showContextMenu($event, order)">
                                                        {{ momentObj(order.booking_date).format('ddd, DD MMM YYYY') }}
                                                    </div>
                                                </template>
                                                <template #item-handymans="order">
                                                    <div @contextmenu.prevent.stop="showContextMenu($event, order)">
                                                        {{ order?.handymans?.map(handyman => {
                                                            let role = handyman?.roles[0];
                                                            
                                                            // If order status is in specific states, check handyman_status
                                                            if (['assigned', 'processing', 'engineer_completed'].includes(order.status)) {
                                                                return handyman?.handyman_status == 1 ? handyman?.first_name : '';
                                                            } else {
                                                                // For other statuses, check role
                                                                return role?.name === 'provider' ? 'Admin' : handyman?.first_name;
                                                            }
                                                        }).filter(name => name !== '').join(', ') }}
                                                    </div>
                                                </template>
                                                <template #item-customer="order">
                                                    <div @contextmenu.prevent.stop="showContextMenu($event, order)">
                                                        {{ order?.customer?.name }}
                                                    </div>
                                                </template>
                                                <template #item-services="order">
                                                    <div @contextmenu.prevent.stop="showContextMenu($event, order)">
                                                        {{ order?.services?.map(service => service?.name).join(', ') }}
                                                    </div>
                                                </template>
                                                <template #item-address="order">
                                                    <div @contextmenu.prevent.stop="showContextMenu($event, order)">
                                                        {{
                                                            (order?.address?.address) + 
                                                            (order?.address?.address_1 ? ', ' + order?.address?.address_1 : '') +
                                                            (order?.address?.postal_code ? ', ' + order?.address?.postal_code : '')
                                                        }}
                                                    </div>
                                                </template>
                                                <template #item-status="order">
                                                    <div class="text-capitalize" @contextmenu.prevent.stop="showContextMenu($event, order)">
                                                        {{ order?.status.replace('_', ' ') }}
                                                    </div>
                                                </template>
                                                <!-- <template #item-action="order">
                                                    <button class="btn btn-sm btn-theme" @click="$goToPage('/admin/orders/' + order.order_number)">View</button>
                                                </template> -->
                                                <template #empty>
                                                    <p>No orders found</p>
                                                </template>

                                            </Vue3EasyDataTable>
                                            <!-- <table class="table table-borderless hm-fs-12 align-middle table-striped hm-table-fixed">
                                                <thead>
                                                    <tr>
                                                        <th scope="col" class="bg-theme">Date</th>
                                                        <th scope="col" class="bg-theme">Handyman</th>
                                                        <th scope="col" class="bg-theme">Client</th>
                                                        <th scope="col" class="bg-theme">Service</th>
                                                        <th scope="col" class="bg-theme">Address</th>
                                                        <th scope="col" class="bg-theme">Post Code</th>
                                                        <th scope="col" class="bg-theme">Status</th>
                                                        <th scope="col" class="bg-theme text-center" width="10%">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-if="processing" class="text-center">
                                                        <td colspan="8">
                                                            <Loader />
                                                        </td>
                                                    </tr>
                                                    <tr v-else-if="orders.length === 0" class="text-center">
                                                        <td colspan="8">
                                                        {{ (filters.customer ==='' ? 'Start typing to search' : 'No orders found') }}
                                                        </td>
                                                    </tr>
                                                    <tr v-else v-for="order in orders" :key="order.id">
                                                        <td>{{ momentObj(order.booking_date).format('ddd, Do MMM YYYY') }}</td>
                                                        <td>
                                                            {{ order?.handymans?.map(item => {
                                                                let role = item?.roles[0];
                                                                
                                                                // If order status is in specific states, check handyman_status
                                                                if (['assigned', 'processing', 'engineer_completed'].includes(order.status)) {
                                                                    return item?.handyman_status == 1 ? item?.first_name : '';
                                                                } else {
                                                                    // For other statuses, check role
                                                                    return role?.name === 'provider' ? 'Admin' : item?.first_name;
                                                                }
                                                            }).filter(name => name !== '').join(', ') }}
                                                        </td>
                                                        <td class="text-capitalize">{{ order?.customer?.first_name }}</td>
                                                        <td>{{ order?.order_items?.map(item => item?.service?.name).join(', ') }}</td>
                                                        <td class="text-capitalize">{{ order?.address?.address + ', ' + order?.address?.address_1 }}</td>
                                                        <td class="text-capitalize">{{ order?.address?.postal_code }}</td>
                                                        <td class="text-capitalize">{{ order?.status.replace('_', ' ') }}</td>
                                                        <td class="text-center" width="10%">
                                                            <button class="btn btn-sm btn-theme" @click="$goToPage('/admin/orders/' + order.order_number)">View</button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-5 col-md-12">
                                <div class="card">
                                    <div class="card-header text-black p-2">Due Dates Services</div>
                                    <div class="card-body p-2">
                                        <Vue3EasyDataTable
                                            ref="dueDateServiceTable"
                                            :headers="dueDateServiceDataTableObj.headers"
                                            :items="dueDateServiceDataTableObj.items"
                                            :rows-per-page="10"
                                            :loading="dueDateServiceDataTableObj.loading"
                                            buttons-pagination
                                            theme-color="#1d90ff"
                                            table-class-name="hm-easy-table"
                                        >
                                            <template #loading>
                                                <Loader />
                                            </template>
                                            <template #item-due_date="service">
                                                <div class="text-nowrap" @contextmenu.prevent.stop="showDueDateContextMenu($event, service)">{{ momentObj(service?.due_date).format('ddd, DD MMM YYYY') }}</div>
                                            </template>
                                            <template #item-client="service">
                                                <div @contextmenu.prevent.stop="showDueDateContextMenu($event, service)">{{ service?.customer?.name }}</div>
                                            </template>
                                            <template #item-service="service">
                                                <div @contextmenu.prevent.stop="showDueDateContextMenu($event, service)">{{ service?.service?.name }}</div>
                                            </template>
                                            <template #item-address="service">
                                                <div @contextmenu.prevent.stop="showDueDateContextMenu($event, service)">{{ service?.address?.address + (service?.address?.address_1 ? ', ' + service?.address?.address_1 : '') }}</div>
                                            </template>
                                            <template #item-postal_code="service">
                                                <div class="text-nowrap" @contextmenu.prevent.stop="showDueDateContextMenu($event, service)">{{ service?.address?.postal_code }}</div>
                                            </template>
                                            <template #empty>
                                                <p>No orders found</p>
                                            </template>
                                        </Vue3EasyDataTable>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="card">
                                    <div class="card-header text-black p-2">Properties</div>
                                    <div class="card-body p-2">
                                        <div class="table-responsive">
                                            <Vue3EasyDataTable
                                                ref="propertiesTable"
                                                :headers="propertiesDataTableObj.headers"
                                                :items="propertiesDataTableObj.items"
                                                :rows-per-page="10"
                                                :loading="propertiesDataTableObj.loading"
                                                buttons-pagination
                                                theme-color="#1d90ff"
                                                table-class-name="hm-easy-table"
                                                body-row-class-name="cursor-pointer"
                                                @click-row="viewProperty"
                                            >
                                                <template #loading>
                                                    <Loader />
                                                </template>
                                                <template #item-property="property">
                                                    <div class="text-capitalize">
                                                        {{
                                                            property?.address + 
                                                            (property?.address_1 ? ', ' + property?.address_1 : '') +
                                                            (property?.address_2 ? ', ' + property?.address_2 : '')
                                                        }}
                                                    </div>
                                                </template>
                                                <template #item-client="property">
                                                    <div class="text-capitalize">{{ property?.user?.name }}</div>
                                                </template>
                                                <template #item-postal_code="property">
                                                    <div>{{ property?.postal_code }}</div>
                                                </template>
                                                <template #empty>
                                                    <p>No properties found</p>
                                                </template>
                                            </Vue3EasyDataTable>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="card">
                                    <div class="card-header text-black p-2">Customers</div>
                                    <div class="card-body p-2">
                                        <div class="table-responsive">
                                            <Vue3EasyDataTable
                                                ref="customerTable"
                                                :headers="customerDataTableObj.headers"
                                                :items="customerDataTableObj.items"
                                                :rows-per-page="10"
                                                :loading="customerDataTableObj.loading"
                                                buttons-pagination
                                                theme-color="#1d90ff"
                                                table-class-name="hm-easy-table"
                                                body-row-class-name="cursor-pointer"
                                                @click-row="viewCustomer"
                                            >
                                                <template #loading>
                                                    <Loader />
                                                </template>
                                                <template #item-name="customer">
                                                    {{ customer?.name }}
                                                </template>
                                                <template #item-email="customer">
                                                    {{ customer?.email }}
                                                </template>
                                                <template #item-phone="customer">
                                                    {{ customer?.phone_number }}
                                                </template>
                                                <template #empty>
                                                    <p>No customers found</p>
                                                </template>
                                            </Vue3EasyDataTable>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Right click context -->
    <vue-simple-context-menu
        element-id="handleRightClickGlobalSearch"
        :options="contextMenuOptions"
        ref="rightClickMenu"
        @option-clicked="handleRightClickMenuAction"
    >
    </vue-simple-context-menu>

    <!-- Due Date Context Menu -->
    <vue-simple-context-menu
        element-id="handleRightClickDueDate"
        :options="dueDateContextMenuOptions"
        ref="dueDateRightClickMenu"
        @option-clicked="handleDueDateRightClickMenuAction"
    >
    </vue-simple-context-menu>

    <!-- Customer Details Modal -->
    <CustomerDetails
        v-if="selectedOrder"
        ref="customerDetails" 
        :order="selectedOrder" 
    />

    <!-- Add Attachment Modal -->
    <AddAttachment
        v-if="selectedOrder"
        ref="addAttachmentModal"
        :orderId="selectedOrder.id"
    />

    <!-- Move order to pending -->
    <MoveToPending
        v-if="selectedOrder"
        ref="moveToPendingModal"
        :order="selectedOrder"
    />

    <!-- Move order to processing -->
    <MoveToProcessing
        v-if="selectedOrder"
        ref="moveToProcessingModal"
        :order="selectedOrder"
    />

    <!-- Cancel Order Modal -->
    <CancelOrder
        v-if="selectedOrder"
        ref="cancelOrderModal"
        :order="selectedOrder"
    />

    <!-- Assign Order Modal -->
    <AssignOrder
        v-if="selectedOrder"
        ref="assignOrderModal"
        :order="selectedOrder"
        :action="assignOrReassign"
    />

    <!-- Quotation Modal -->
    <Quotation
        v-if="selectedOrder"
        ref="quotationModal"
        :order="selectedOrder"
        :action="orderAction"
    />

    <!-- Update Order Status Modal -->
    <UpdateOrderStatus
        v-if="selectedOrder"
        ref="updateOrderStatusModal"
        :order="selectedOrder"
        :action="orderAction"
    />

    <!-- Move order to completed -->
    <MoveToCompleted
        v-if="selectedOrder"
        ref="moveToCompletedModal"
        :order="selectedOrder"
    />

    <!-- Due Date Create Order Modal -->
    <DueDateCreateOrder
        v-if="dueDateSelectedOrder"
        ref="dueDateCreateOrderModal"
        :order="dueDateSelectedOrder"
    />
</template>
<script>
import VueSimpleContextMenu from "vue-simple-context-menu";
import "vue-simple-context-menu/dist/vue-simple-context-menu.css";

import { debounce } from 'lodash';
import { appMixin } from "../../mixin/appMixin";
import Loader from '../partials/Loader.vue';
import VueSelect from '../partials/VueSelect.vue';
import CustomerDetails from "../Order/CustomerDetails.vue";
import AddAttachment from "../Order/AddAttachment.vue";
import CancelOrder from "../Order/CancelOrder.vue";
import AssignOrder from "../Order/AssignOrder.vue";
import MoveToProcessing from "../Order/MoveToProcessing.vue";
import MoveToPending from "../Order/MoveToPending.vue";
import Quotation from "../Order/Quotation.vue";
import UpdateOrderStatus from "../Order/UpdateOrderStatus.vue";
import MoveToCompleted from "../Order/MoveToCompleted.vue";
import DueDateCreateOrder from "../Order/DueDateCreateOrder.vue";

export default {
    mixins: [appMixin],
    components: {
        Loader,
        VueSelect,
        VueSimpleContextMenu,
        CustomerDetails,
        AddAttachment,
        CancelOrder,
        AssignOrder,
        MoveToProcessing,
        MoveToPending,
        Quotation,
        UpdateOrderStatus,
        MoveToCompleted,
        DueDateCreateOrder
    },
    data() {
        return {
            processing: false,
            isClearing: false, // Add flag to prevent search during clear
            search: '',
            secondarySearch: '',
            filterType: 'advanced', // advanced, general
            searchTerm: '',
            filters: {
                customers: [],
                handymans: [],
                properties: [],
                status: [],
                service: [],
                date_type: 'last_30_days', // last_7_days, last_15_days, last_30_days, this_month, last_month, this_year, last_year, custom
                start_date: this.moment().subtract(30, 'day'),
                end_date: this.moment(),
                date_range: [
                    this.moment().format('YYYY-MM-DD'),
                    this.moment().add(1, 'month').format('YYYY-MM-DD')
                ],
            },
            debouncedFetchOrders: null,
            orderDataTableObj: {
                loading: false,
                headers: [
                    {text: "Service Date", value: "booking_date", sortable: false},
                    {text: "Handyman", value: "handymans", sortable: false},
                    {text: "Client", value: "customer", sortable: false},
                    {text: "Service", value: "services", sortable: false},
                    {text: "Address", value: "address", sortable: false},
                    //{text: "Postal Code", value: "postal_code", sortable: false},
                    {text: "Status", value: "status", sortable: false},
                    //{text: "Action", value: "action", sortable: false},
                ],
                items: []
            },
            customerDataTableObj: {
                loading: false,
                headers: [
                    {text: "Name", value: "name", sortable: false},
                    {text: "Email", value: "email", sortable: false},
                    {text: "Phone", value: "phone", sortable: false},
                ],
                items: []
            },
            dueDateServiceDataTableObj: {
                loading: false,
                headers: [
                    {text: "Due Date", value: "due_date", sortable: false},
                    {text: "Client", value: "client", sortable: false},
                    {text: "Service", value: "service", sortable: false},
                    {text: "Address", value: "address", sortable: false},
                    {text: "Postal Code", value: "postal_code", sortable: false},
                ],
                items: []
            },
            propertiesDataTableObj: {
                loading: false,
                headers: [
                    {text: "Property", value: "property", sortable: false},
                    {text: "Client", value: "client", sortable: false},
                    {text: "Postal Code", value: "postal_code", sortable: false},
                ],
                items: []
            },
            orders:[], 
            customers: [],
            dueDateServices: [],
            customerOptions: [],
            propertyOptions: [],
            handymanOptions: [],
            serviceOptions: [],
            statusOptions: [
                { id: 'all', name: 'Select All' },
                { id: 'pending', name: 'Pending' },
                { id: 'assigned', name: 'Assigned' },
                { id: 'processing', name: 'Processing' },
                { id: 'quotation', name: 'Quotation' },
                { id: 'engineer_completed', name: 'Engineer Completed' },
                { id: 'completed', name: 'Completed' },
                { id: 'cancelled', name: 'Cancelled' }
            ],
            orderAction: null,
            assignOrReassign: null,
            selectedOrder: null,
            contextMenuOptions: [],
            availableOptions: {
                pending: [
                    {name: "Move To Assigned", action: "move_to_assigned"},
                    {name: "View Order", action: "order_view" },
                    {name: "View Customer", action: "view_customer" },
                    {name: "Add Attachment", action: "add_attachment" },
                    {name: "Cancel Order", action: "cancel" },
                    //{name: "Duplicate Order", action: "duplicate" },
                ],
                assigned: [
                    {name: "Back To Pending", action: "move_to_pending"},
                    {name: "Move To Processing", action: "move_to_processing"},
                    {name: "View Order", action: "order_view" },
                    {name: "View Customer", action: "view_customer" },
                    {name: "Add Attachment", action: "add_attachment" },
                    {name: "Reassign Order", action: "reassign_order" },
                    {name: "Cancel Order", action: "cancel" },
                    //{name: "Duplicate Order", action: "duplicate" },
                ],
                processing: [
                    {name: "Back To Pending", action: "move_to_pending"},
                    {name: "Back To Assigned", action: "move_to_assigned"},
                    {name: "Move To Quotation", action: "move_to_quotation"},
                    {name: "Move To Completed", action: "move_to_completed"},
                    {name: "View Order", action: "order_view" },
                    {name: "View Customer", action: "view_customer" },
                    {name: "Add Attachment", action: "add_attachment" },
                    {name: "Cancel Order", action: "cancel" },
                    //{name: "Duplicate Order", action: "duplicate" },
                ],
                quotation: [
                    {name: "Back To Processing", action: "move_to_processing"},
                    {name: "Move To Completed", action: "move_to_completed"},
                    {name: "Quotation Declined", action: "quotation_declined"},
                    {name: "Quotation Approved", action: "quotation_approved"},
                    {name: "View Order", action: "order_view" },
                    {name: "View Customer", action: "view_customer" },
                    {name: "Add Attachment", action: "add_attachment" },
                    {name: "Cancel Order", action: "cancel" },
                    //{name: "Duplicate Order", action: "duplicate" },
                ],
                engineer_completed: [
                    {name: "Move To Completed", action: "move_to_completed"},
                    {name: "Move To Quotation", action: "move_to_quotation"},
                    {name: "Back To Processing", action: "move_to_processing"},
                    {name: "View Order", action: "order_view" },
                    {name: "View Customer", action: "view_customer" },
                    {name: "Add Attachment", action: "add_attachment" },
                    {name: "Cancel Order", action: "cancel" },
                    //{name: "Duplicate Order", action: "duplicate" },
                ],
                completed: [
                    {name: "View Order", action: "order_view" },
                    {name: "View Customer", action: "view_customer" },
                    {name: "Add Attachment", action: "add_attachment" },
                ],
                canceled: [
                    {name: "View Order", action: "order_view" },
                    {name: "View Customer", action: "view_customer" },
                    {name: "Add Attachment", action: "add_attachment" },
                ]
            },
            dueDateContextMenuOptions: [],
            dueDateSelectedOrder: null,
        };
    },
    created() {
        this.debouncedFetchOrders = debounce(this.fetchFilteredOrders, 300);
    },
    mounted() {
        this.$emitter.on('focusOnSearch', (data) => {
            if (data.action === 'openGlobalSearchModal') {
                this.openSearchModal();
            }
        });

        // Reset selected order
        this.$emitter.on('reset-selected-order', () => {
            this.selectedOrder = null;
            this.dueDateSelectedOrder = null;
        });

        // Listen to due-date-order-created event
        this.$emitter.on('due-date-order-created', (order) => {
            // Find the dueDateServiceDataTableObj.items id and match it with order.servie_id
            // And update the order_number
            this.dueDateServiceDataTableObj.items = this.dueDateServiceDataTableObj.items.map(item => {
                if (item.id === order.due_date_id) {
                    item.order_id = order.id;
                    item.order_number = order.order_number;
                }
                return item;
            });
        });

        // Fetch initial data
        this.fetchCustomers();
        this.fetchHandymans();
        this.fetchServices();

        // Search initial data
        this.$nextTick(() => {
            //this.searchOrder();
        });
    },
    computed: {
        exampleDate() {
            return this.moment().format('DD/MM/YY');
        },
        exampleMonthYear() {
            return this.moment().format('MM/YYYY');
        },
        exampleYear() {
            return this.moment().format('YYYY');
        }
    },
    watch: {
        filters: {
            handler() {
                // Don't trigger search if we're in the middle of clearing
                if (!this.isClearing) {
                    this.searchTerm = '';
                    this.filterType = 'advanced';
                    this.searchOrder();
                }
            },
            deep: true
        }
    },
    methods: {
        openSearchModal() {
            $('#searchOrderModal').modal('show');
            
            // Focus input after modal is fully shown
            $('#searchOrderModal').on('shown.bs.modal', () => {
                //this.$refs.searchInput.focus();
            });
        },
        generalSearch() {
            this.filterType = 'general';
            this.searchOrder();
        },
        searchOrder() {
            /* const leadingTrimmed = this.search.replace(/^\s+/, '');

            // Set primarySearch based on whether the trimmed input is empty
            this.search = leadingTrimmed.length > 0 ? leadingTrimmed : '';

            // If search is not empty
            if (this.search) {
                this.processing = true;
            }

            // Filter the secondary search
            const leadingTrimmedSecondary = this.secondarySearch.replace(/^\s+/, '');
            this.secondarySearch = leadingTrimmedSecondary.length > 0 ? leadingTrimmedSecondary : '';

            // If secondary search is not empty
            if (this.secondarySearch) {
                this.processing = true;
            } */

            // Trigger search
            this.debouncedFetchOrders();
        },
        async fetchFilteredOrders() {
            let self = this;
            self.orderDataTableObj.loading = true;
            self.customerDataTableObj.loading = true;
            self.dueDateServiceDataTableObj.loading = true;
            self.propertiesDataTableObj.loading = true;

            // Prepre post data and remove all empty values
            let postData = {
                customer: this.filters.customers ? this.filters.customers.filter(id => id !== 'all') : [],
                property: this.filters.properties ? this.filters.properties.map(property => property.id).filter(id => id !== 'all') : [],
                handyman: this.filters.handymans ? this.filters.handymans.filter(id => id !== 'all') : [],
                service: this.filters.service ? this.filters.service.filter(id => id !== 'all') : [],
                status: this.filters.status ? this.filters.status.filter(id => id !== 'all') : [],
                date_range: this.filters.date_range,
                date_type: this.filters.date_type,
                start_date: this.filters.start_date,
                end_date: this.filters.end_date,
                filter_type: this.filterType,
            };

            // Check if filter type is general
            if (this.filterType === 'general') {
                postData = {
                    search_term: this.searchTerm,
                    filter_type: this.filterType,
                };
            }

            await axios.post('/admin/dashboard/search', postData)
                .then(response => {
                    self.orderDataTableObj.items = response.data.orders || [];
                    self.orderDataTableObj.loading = false;

                    self.customerDataTableObj.items = response.data.customers || [];
                    self.customerDataTableObj.loading = false;

                    self.dueDateServiceDataTableObj.items = response.data.due_date_services || [];
                    self.dueDateServiceDataTableObj.loading = false;

                    self.orders = response.data.orders || [];
                    self.customers = response.data.customers || [];
                    self.dueDateServices = response.data.due_date_services || [];

                    // Set properties
                    self.propertiesDataTableObj.items = response.data.properties || [];
                    self.propertiesDataTableObj.loading = false;
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    self.processing = false;
                });
        },
        clearSearch() {
            this.isClearing = true;
            this.searchTerm = '';
            this.filters = {
                customers: [],
                properties: [],
                handymans: [],
                service: [],
                status: [],
                date_type: 'last_30_days', // last_7_days, last_15_days, last_30_days, this_month, last_month, this_year, last_year, custom
                start_date: this.moment().subtract(30, 'day').format('YYYY-MM-DD'),
                end_date: this.moment().format('YYYY-MM-DD'),
                date_range: [
                    this.moment().subtract(30, 'day').format('YYYY-MM-DD'),
                    this.moment().format('YYYY-MM-DD')
                ]
            };
            
            // Reset all data tables
            this.orderDataTableObj.items = [];
            this.customerDataTableObj.items = [];
            this.dueDateServiceDataTableObj.items = [];

            // Reset processing state
            this.processing = false;

            // Reset the clearing flag after a short delay to ensure all reactive updates are complete
            this.$nextTick(() => {
                this.isClearing = false;
            });
        },
        fetchCustomers() {
            let self = this;
            axios.post('/api/admin/order-customers')
                .then(response => {
                    let data = response.data;
                    if(data.customers) {
                        self.customerOptions = [{id: 'all', name: 'Select All'}];
                        self.customerOptions.push(...data.customers.map(customer => ({
                            id: customer.id,
                            name: customer.name,
                            addresses: customer.addresses,
                        })));

                        self.preparePropertiesOptions();
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        },
        fetchHandymans() {
            let self = this;
            axios.post('/api/admin/handyman-list')
                .then(response => {
                    self.handymanOptions = [{id: 'all', name: 'Select All'}];
                    self.handymanOptions.push(...response.data.handymans.map(handymans => ({
                        id: handymans.id,
                        name: handymans.name,
                    })));
                })
                .catch(error => {
                    console.log(error);
                });
        },
        fetchServices() {
            let self = this;
            axios.post('/api/admin/order-services')
                .then(response => {
                    self.serviceOptions = [{id: 'all', name: 'Select All'}];
                    self.serviceOptions.push(...response.data.services.map(service => ({
                        id: service.id,
                        name: service.name,
                    })));
                })
                .catch(error => {
                    console.log(error);
                });
        },
        handleCustomerSelect(option) {
            // Check if option.id === 'all' then remove all other selected options
            if(option.id === 'all') {
                this.filters.customers = ['all']
            }
            else {
                // Remove all if selected
                this.filters.customers = this.filters.customers.length ? this.filters.customers.filter(id => id !== 'all') : [];
            }
            this.preparePropertiesOptions();
        },
        handleCustomerRemove(option) {
            
        },
        preparePropertiesOptions() {
            // Check all customer is selected
            let allCustomers = [];
            if(this.filters.customers.includes('all') || this.filters.customers.length === 0) {
                allCustomers = this.customerOptions.map(option => option.id).filter(id => id !== 'all' && id !== 'remove-all');
            }
            else {
                allCustomers = this.filters.customers;
            } 
            
            const selectedCustomers = this.customerOptions.filter(customer =>
                allCustomers.includes(customer.id)
            );

            // Prepare options with global Select All and customer groups
            this.propertyOptions = [
                // Global Select All option
                {
                    group: 'Select Properties',
                    properties: [{name: 'Select All', id: 'all', customer_id: 'all'}]
                },
                // Customer groups
                ...selectedCustomers.map(customer => ({
                    group: customer.name,
                    properties: customer.addresses.map(address => ({
                        name: address.full_address,
                        id: address.id,
                        customer_id: customer.id
                    }))
                }))
            ];   
        },
        handlePropertySelect(option) {
            const selectedOption = option[0]?.id || option.id;

            if(selectedOption === 'all') {
                this.filters.properties = [{id: 'all', name: 'Select All'}]
            }
            else {
                // Remove all if selected
                this.filters.properties = this.filters.properties.length ? this.filters.properties.filter(property => property.id !== 'all') : [];
            }
        },
        handleHandymanSelect(option) {
            // Check if option.id === 'all' then remove all other selected options
            if(option.id === 'all') {
                this.filters.handymans = ['all']
            }
            else {
                // Remove all if selected
                this.filters.handymans = this.filters.handymans.length ? this.filters.handymans.filter(id => id !== 'all') : [];
            }
        },
        handleStatusSelect(option) {
            // Check if option.id === 'all' then remove all other selected options
            if(option.id === 'all') {
                this.filters.status = ['all']
            }
            else {
                // Remove all if selected
                this.filters.status = this.filters.status.length ? this.filters.status.filter(id => id !== 'all') : [];
            }
        },
        handleServiceSelect(option) {
            // Check if option.id === 'all' then remove all other selected options
            if(option.id === 'all') {
                this.filters.service = ['all']
            }
            else {
                // Remove all if selected
                this.filters.service = this.filters.service.length ? this.filters.service.filter(id => id !== 'all') : [];
            }
        },
        showContextMenu(event, order) {
            this.contextMenuOptions = this.availableOptions[order.status];
            this.$refs.rightClickMenu.showMenu(event, order)
        },
        handleRightClickMenuAction(event) {
            let order = event.item;
            let action = event.option.action;
            this.selectedOrder = order;

            // Check if action is valid
            if (!action) {
                return;
            }

            // If action is view_order then view order
            if (action === 'order_view') {
                window.location.href = "/admin/orders/" + order.order_number;
                return;
            }
            else if(action === 'view_customer') {
                this.$nextTick(() => {
                    if (this.$refs.customerDetails) {
                        this.$refs.customerDetails.showModal();
                    }
                });
                return;
            }
            else if(action === 'add_attachment') {
                this.$nextTick(() => {
                    if (this.$refs.addAttachmentModal) {
                        this.$refs.addAttachmentModal.showModal();
                    }
                });
                return;
            }
            else if(action === 'move_to_assigned') {
                this.assignOrReassign = 'assign';
                this.$nextTick(() => {
                    if (this.$refs.assignOrderModal) {
                        this.$refs.assignOrderModal.showModal();
                    }
                });
                return;
            }
            else if(action === 'reassign_order') {
                this.assignOrReassign = 'reassign';
                this.$nextTick(() => {
                    if (this.$refs.assignOrderModal) {
                        this.$refs.assignOrderModal.showModal();
                    }
                });
                return;
            }
            else if(action === 'move_to_pending') {
                this.$nextTick(() => {
                    if (this.$refs.moveToPendingModal) {
                        this.$refs.moveToPendingModal.showModal();
                    }
                });
                return;
            }
            else if(action === 'move_to_processing') {
                this.$nextTick(() => {
                    if (this.$refs.moveToProcessingModal) {
                        this.$refs.moveToProcessingModal.showModal();
                    }
                });
                return;
            }
            else if(action === 'move_to_quotation') {
                this.$nextTick(() => {
                    if (this.$refs.quotationModal) {
                        this.orderAction = 'move_to_quotation';
                        this.$refs.quotationModal.showModal();
                    }
                });
                return;
            }
            else if(action === 'quotation_declined') {
                this.$nextTick(() => {
                    if (this.$refs.quotationModal) {
                        this.orderAction = 'quotation_declined';
                        this.$refs.quotationModal.showModal();
                    }
                });
                return;
            }
            else if(action === 'quotation_approved') {
                this.$nextTick(() => {
                    if (this.$refs.updateOrderStatusModal) {
                        this.orderAction = 'quotation_approved';
                        this.$refs.updateOrderStatusModal.showModal();
                    }
                });
                return;
            }
            else if(action === 'move_to_completed') {
                this.$nextTick(() => {
                    if (this.$refs.moveToCompletedModal) {
                        this.$refs.moveToCompletedModal.showModal();
                    }
                });
                return;
            }
            else if(action === 'duplicate') {
                this.$nextTick(() => {
                    if (this.$refs.duplicateOrderModal) {
                        this.$refs.duplicateOrderModal.showModal();
                    }
                });
                return;
            }
            else if(action === 'cancel') {
                this.$nextTick(() => {
                    if (this.$refs.cancelOrderModal) {
                        this.$refs.cancelOrderModal.showModal();
                    }
                });
                return;
            }
        },
        viewCustomer(customer) {
            window.location.href = `/admin/users/${customer.id}/edit`;
            return;
        },
        viewProperty(property) {
            window.location.href = `/admin/users/edit-address/${property.user_id}/${property.id}`;
            return;
        },
        showDueDateContextMenu(event, item) {
            let options = [{'name': 'Assign Order', 'action': 'assign_order'}];
            // Check if item.order_number is not null
            if (item.order_number) {
                options = [{'name': 'View Order', 'action': 'view_order'}];
            }
            this.dueDateContextMenuOptions = options;
            this.$refs.dueDateRightClickMenu.showMenu(event, item)
        },
        handleDueDateRightClickMenuAction(event) {
            let item = event.item;
            let action = event.option.action;
            this.dueDateSelectedOrder = item;
            console.log(action, item.order_number);
            if (action === 'view_order') {
                window.location.href = "/admin/orders/" + item.order_number;
                return;
            }
            else if(action === 'assign_order') {
                this.$nextTick(() => {
                    if (this.$refs.dueDateCreateOrderModal) {
                        this.$refs.dueDateCreateOrderModal.showModal();
                    }
                });
                return;
            }
        }
    },
};
</script>